module.exports = __webpack_public_path__ + "static/media/more-vertical.665f4697.svg";